import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var Show = /*#__PURE__*/function () {
  function Show(context) {
    _classCallCheck(this, Show);

    this.context = context;
  }

  _createClass(Show, [{
    key: "halls",
    value: function halls(id) {
      return this.context.http.get("/msvc/v1/shows/".concat(id, "/halls"));
    }
  }, {
    key: "all",
    value: function all(params) {
      return this.context.http.get('/msvc/v1/shows/all', params);
    }
  }, {
    key: "sectors",
    value: function sectors(id) {
      return this.context.http.get("/msvc/v1/shows/".concat(id, "/sectors"));
    }
  }, {
    key: "allSectors",
    value: function allSectors(params) {
      return this.context.http.get('/msvc/v1/shows/showSectors/all', params);
    }
  }, {
    key: "sectorById",
    value: function sectorById(id) {
      return this.context.http.get("/msvc/v1/shows/showSectors/all/".concat(id));
    }
  }, {
    key: "showInfo",
    value: function showInfo(id) {
      return this.context.http.get("/msvc/v1/onlineshows/views/".concat(id));
    }
  }]);

  return Show;
}();

export default Show;